import { MenuProps } from '@mui/material'

/**
 * Compact style of the navbar menu: dense items, small gaps and body2 text. Pass it to the menu
 * and to every submenu (`NestedMenuItem`'s `MenuProps`), since each submenu is its own popover.
 */
export const compactMenuProps: Pick<MenuProps, 'MenuListProps' | 'sx'> = {
  MenuListProps: { dense: true },
  sx: {
    '& .MuiMenuItem-root': { py: 0.25 },
    // room above input fields, so their floating labels don't touch the item above
    '& .MuiMenuItem-root:has(.MuiInputBase-root)': { pt: 0.75 },
    '& .MuiTypography-body1': { typography: 'body2' },
    '& .MuiDivider-root': { my: 0.5 },
  },
}
